namespace TabAurous.HR {
    export interface HolidaysForm {
        Date: Serenity.DateEditor;
        HolidayName: Serenity.StringEditor;
        Narration: Serenity.StringEditor;
    }

    export class HolidaysForm extends Serenity.PrefixedContext {
        static formKey = 'HR.Holidays';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HolidaysForm.init)  {
                HolidaysForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;

                Q.initFormType(HolidaysForm, [
                    'Date', w0,
                    'HolidayName', w1,
                    'Narration', w1
                ]);
            }
        }
    }
}
